import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SvgImages } from "../../Utils/LocalImages";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import { toast } from "react-toastify";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import Image from "../../Components/Reusable/Image";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import QuestionBankService from "../../Services/QuestionBankService";
import RoutesPath from "../../Utils/RoutesPath";
import { Modal, ModalBody } from "react-bootstrap";
import { FileUploader } from "react-drag-drop-files";
import ApiConstants from "../../Utils/ApiConstant";
import { handleApiErrors } from "../../Utils/Utils";

import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import ClassService from "../../Services/ClassService";
import SubjectService from "../../Services/SubjectService";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputType, validationRegex } from "../../Utils/Utils";
import * as yup from "yup";
import DataProvider from "../../Utils/DataProvider";
import { AuthContext } from "../../Context/authContext";

const QuestionBank = () => {
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [getStatusChangeData, setStatusChangeData] = useState({});
  const [offset, setOffset] = useState(0);
  const [limit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState(null);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [mediumList, setMediumList] = useState(DataProvider.mediumList);
  const [selectedMedium, setSelectedMedium] = useState("");
  const [studyMaterial, setStudyMaterial] = useState({});
  const [resetSubject, setResetSubject] = useState(false);
  const [selectedQuestionsCount, setSelectedQuestionsCount] = useState(0);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext)


  const stepOneValidations = yup.object().shape({
    class_id: validationRegex.required,
    subject: validationRegex.required,
    medium: validationRegex.required
  });
  const { register: registerStepOne, handleSubmit: handleSubmitStepOne, setValue: setValuesStepOne, formState: { errors: errorsStepOne }, watch: watchStepOne, getValues: getValuesStepOne, reset: resetStepOne } = useForm({
    resolver: yupResolver(stepOneValidations),
    defaultValues: {
      class_id: studyMaterial ? studyMaterial?.class_id : "",
      subject: studyMaterial ? studyMaterial?.subject_id : "",
      medium: studyMaterial ? studyMaterial?.medium : "",
    },
  });

  useEffect(() => {
    if (selectedClass) {
      getAllSubjects(selectedClass);
    } else {
      setSubjects([]);
    }
  }, [selectedClass]);

  const getAllClasses = async () => {
    try {
      const response = await ClassService.getAllClassesWithoutPagination();
      setClasses(response.data);

    } catch (error) {
      handleApiErrors(error);
    }
  };

  const getAllSubjects = async (classId) => {
    try {
      const response = await SubjectService.getAllSubjectsWithoutPagination(classId);
      setSubjects(response.data);

    } catch (error) {
      handleApiErrors(error);
    }
  };
  useEffect(() => { getAllClasses() }, []);

  const fetchData = async () => {
    try {
      const response = await QuestionBankService.getAllQuestions(offset, limit, searchQuery || "",
        selectedClass || "",
        selectedSubject || "",
        selectedMedium || ""
      );
      setData(response.data);
      setAvailableDataCount(response.availableDataCount);

      if (offset !== 0 && (offset * limit) > (availableDataCount - 1)) {
        setOffset(offset - 1)
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const deleteSingleQuestion = async (id) => {
    try {
      await QuestionBankService.deleteQuestion([id]);
      toast.success("Question Deleted successfully");
      setShowDeleteModal(false);

      setOffset(0);
      fetchData();
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const bulkUploadQuestions = async (file) => {
    try {
      await QuestionBankService.bulkUploadQuestions(file);
      toast.success("Questions Uploaded successfully");
      setShowBulkUploadModal(false);

      setOffset(0);
      fetchData();
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const deleteMultipleQuestions = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) !== -1) {
        const itemsToDelete = data
          .filter((item) => item.isChecked)
          .map((item) => item.id);
        await QuestionBankService.deleteQuestion(itemsToDelete);
        toast.success('Questions Deleted successfully');
        setShowDeleteModal(false);
        setOffset(0);
        fetchData();
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      toast.error("An error occurred while deleting questions");
    }
  };

  const ChangeStatus = async (id, status) => {
    try {
      const response = await QuestionBankService.updateQuestionStatus(id, status);
      toast.success(response.message);

      var updatedData = data;
      updatedData[updatedData?.findIndex((item) => item.id === id)].is_active = status;
      setData(updatedData);

      setShowConfirmationModal(false);
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [offset, selectedClass, selectedMedium, selectedSubject]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (searchQuery != null) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery]);

  return (
    <div>

      <div className="content" data-number="1">
        <div className="mb-3 d-flex justify-content-between align-items-center">
          <h1 className="black fs-18 fw-600 mb-0">QUESTION BANK</h1>
          <div className="d-flex">
            <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
            <h4 className="fs-12 fw-500 primary mb-0">Question Bank</h4>
          </div>
        </div>

        <div className="table_container" style={{ display: "block" }}>
          <h1 className="black fs-18 fw-600 mb-0">Question Bank List</h1>
          <div className="table_title">
            <div className="table_headings mt-2">
              <h1 className="black fs-18 fw-600 mb-0">
                <div className="table_delete_icon" style={{
                  opacity: (data?.findIndex((item) => item.isChecked) === -1) ? 0.3 : 1,
                  pointerEvents: data?.findIndex((item) => item.isChecked) === -1 ? 'none' : 'auto',
                }}
                  onClick={() => {

                    const questionBankPrivilege = user?.setPrivileges?.find(
                      (priv) => priv.parameter === "Question Bank"
                    );

                    if (!questionBankPrivilege?.delete) {

                      toast.warning("You don't have permission to delete question.");
                      return;
                    }

                    const selectedCount = data.filter((item) => item.isChecked).length;
                    if (selectedCount > 0) {
                      setIsMultipleDelete(true);
                      setSelectedQuestionsCount(selectedCount); // Set the count of selected items
                      setShowDeleteModal(true);
                    }
                  }}>
                  <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
                </div>
              </h1>

              <div className="d-flex gap-4 align-items-center ResponsivesectionQuestionlist">
                <div className="position-relative">
                  <input type="search" className="search_box search_bar" placeholder="Search" onChange={(e) => {
                    setSearchQuery(e.target.value)
                  }} />
                  <Image src={SvgImages.search} style={ImageFilters.gray} className="search_icon" alt="Search Icon" height="20px" />
                </div>

                <ButtonWithIcon text={"Add Question Bank"} icon={SvgImages.plus}
                  onClick={() => {

                    const questionBankPrivilege = user?.setPrivileges?.find(
                      (priv) => priv.parameter === "Question Bank"
                    );
                    if (questionBankPrivilege?.create) {
                      navigate(RoutesPath.addQuestionBank);
                    } else {
                      toast.warning("You don't have permission to add a Question.")
                    }


                  }} />
                <ButtonWithIcon text={"Bulk Upload"} icon={SvgImages.plus} onClick={() => {

                  const questionBankPrivilege = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "Question Bank"
                  );
                  if (questionBankPrivilege?.create) {
                    setShowBulkUploadModal(true)
                  } else {
                    toast.warning("You don't have permission for bulk upload.")
                  }
                }} />
              </div>

            </div>


          </div>

          <div className="row profile_inputs w-100 Responsivesearchbars">
            <div className="col-md-4">
              <CustomDropDown
                placeholder="Filter By Class"
                name="class_id"
                id="class_id"
                additionalClasses="profile_edit"
                inputType={InputType.text}
                register={registerStepOne}
                setValue={setValuesStepOne}
                onChange={(e) => {
                  setSelectedSubject("");
                  setResetSubject(true);
                  setSelectedClass(e.value);
                  setOffset(0);
                }}
                options={
                  [{ value: "", label: "All" }, ...classes.map((e) => { return { value: e._id, label: e.class_name } }) ?? []]
                }
              />
            </div>

            <div className="col-md-4">
              <CustomDropDown
                placeholder="Filter by Subject"
                name="subject"
                id="subject"
                additionalClasses="profile_edit"
                resetValue={resetSubject}
                setResetValue={setResetSubject}
                inputType={InputType.text}
                register={registerStepOne}
                setValue={setValuesStepOne}
                onChange={(e) => {
                  setSelectedSubject(e.value);
                }}
                options={
                  [{ value: "", label: "All" }, ...subjects?.map((e) => { return { value: e._id, label: e.subject_name } }) ?? []]
                }
              />
            </div>

            <div className="col-md-4">
              <CustomDropDown
                placeholder="Filter By Medium"
                name="medium"
                id="medium"
                additionalClasses="profile_edit"
                inputType={InputType.text}
                register={registerStepOne}
                setValue={setValuesStepOne}
                options={
                  [{ value: "", label: "All" }, ...mediumList ?? []]
                }
                onChange={(e) => {
                  setSelectedMedium(e.value);
                }}
              />
            </div>


          </div>
          <div style={{ overflowX: "auto" }}>
            <table className="table mb-0" id="dtHorizontalExample" cellSpacing="0" width="100%">
              <thead>
                <tr className="table_heading">
                  <th scope="col" style={{ width: "5%" }}>
                    <label className="d-flex align-items-center justify-content-center">
                      <input className="cursor-pointer" type="checkbox" style={{ height: "16px", aspectRatio: 1 }} checked={data?.length > 0 && data.findIndex((item) => !item.isChecked) === -1} onChange={
                        (value) => {
                          var updatedData = data;
                          updatedData.map((element) => {
                            element.isChecked = value.target.checked;
                          });
                          setData([...updatedData]);
                        }
                      } />
                      <span className="checkmark"></span>
                    </label>
                  </th>
                  <th scope="col" style={{ width: "10%" }}>Sr No.</th>
                  <th scope="col" style={{ width: "10%" }}>Class</th>
                  <th scope="col" style={{ width: "10%" }}>Medium</th>
                  <th scope="col" style={{ width: "10%" }}>Subject</th>
                  <th scope="col" style={{ width: "10%" }}>Question Bank/SAT Exam </th>
                  <th scope="col" style={{ width: "10%" }}>Question Type</th>
                  <th scope="col" style={{ width: "35%" }}>Question</th>
                  <th scope="col" style={{ width: "10%" }}>Status</th>
                  <th scope="col" style={{ width: "10%" }}>Action</th>
                  <th scope="col" style={{ width: "10%" }}>Status</th>
                </tr>
              </thead>
              <tbody className="bg_light">
                {data?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <label className="d-flex align-items-center justify-content-center">
                        <input className="cursor-pointer" type="checkbox" checked={item.isChecked || false} style={{ height: "16px", aspectRatio: 1 }}
                          onChange={(value) => {
                            var updatedData = data;
                            updatedData[index].isChecked = value.target.checked;
                            setData([...updatedData]);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td>{(limit * (offset)) + (index + 1)}</td>
                    <td>{item.class_name}</td>
                    <td>{item.medium}</td>
                    <td>{item.subject_name}</td>
                    <td>{item.question_type}</td>
                    <td>{item.type_of_question}</td>
                    <td><h2 className="threeLineText fs-14 fs-500 mb-0 w-100" title={item.question.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ')} >{item.question.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ')}</h2></td>
                    <td>
                      <label className="switch" data-bs-target="#change_status" data-bs-toggle="modal">
                        <input type="checkbox" checked={item.is_active}
                          onChange={() => {

                            const questionBankPrivilege = user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Question Bank"
                            )
                            if (!questionBankPrivilege?.update) {

                              toast.warning("You don't have permission to update the status.");
                              return;
                            }

                            setShowConfirmationModal(true);
                            setStatusChangeData(item);
                          }}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                    <td>
                      <div className="d-flex gap_8">
                        <button onClick={() => {

                          const questionBankPrivilege = user?.setPrivileges?.find(
                            (priv) => priv.parameter === "Question Bank"
                          );

                          if (!questionBankPrivilege?.update) {

                            toast.warning("You don't have permission to edit question.");
                            return;
                          }

                          navigate(RoutesPath.editQuestionBank, { state: item });
                        }} className="edit_icons cursor-pointer">
                          <Image src={SvgImages.edit} style={ImageFilters.green} className="add_icons" alt="Edit Icon" />
                        </button>
                        <button className="delete_icons cursor-pointer" onClick={() => {

                          const questionBankPrivilege = user?.setPrivileges?.find(
                            (priv) => priv.parameter === "Question Bank"
                          );

                          if (!questionBankPrivilege?.delete) {

                            toast.warning("You don't have permission to delete question.");
                            return;
                          }

                          setDeleteId(item.id);
                          setIsMultipleDelete(false);
                          setShowDeleteModal(true);
                        }}>
                          <Image src={SvgImages.deleteIcon} style={ImageFilters.red} data-bs-target="#delete-modal" data-bs-toggle="modal" alt="Delete Icon" />
                        </button>
                      </div>
                    </td>
                    <td className="text-capitalize blue">{item.status == "approved" ? <div className="text-success">{item.status}</div> : <div>{item.status == "rejected" ? <div className="text-danger">{item.status}</div> : <div className="blue">{item.status}</div>}</div>}</td>

                  </tr>
                ))}
              </tbody>
            </table>


          </div>
          {generatePaginationFooter(availableDataCount, limit, offset, setOffset)}
        </div>
      </div>


      {/* Delete Questions Modal */}
      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={isMultipleDelete ? `Are you sure you want to delete selected ${selectedQuestionsCount} question${selectedQuestionsCount > 1 ? 's' : ''}?` : "Are you sure you want to delete this question?"}
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => { isMultipleDelete ? deleteMultipleQuestions() : deleteSingleQuestion(deleteId) }}
        theme={ConfirmationModalTheme.error}
      />

      {/* Change Question Status Modal */}
      <ConfirmationModal
        showModal={showConfirmationModal}
        setShowModal={setShowConfirmationModal}
        text={"Are you sure want to change the status?"}
        icon={SvgImages.exclamation_mark} // Specify the path to your delete icon
        rightClickAction={() => { ChangeStatus(getStatusChangeData.id, !getStatusChangeData.is_active) }}
        theme={ConfirmationModalTheme.warning}
      />

      <BulkUploadModal
        showModal={showBulkUploadModal}
        setShowModal={setShowBulkUploadModal}
        onSuccess={(file) => bulkUploadQuestions(file)}
      />
    </div>
  );
};

export default QuestionBank;

const BulkUploadModal = ({ showModal, setShowModal, onSuccess }) => {
  const fileTypes = ["csv", "xlsx", "xls"];

  const handleChange = (file) => {
    onSuccess(file);
  };

  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      dialogClassName="my-0"
      centered // Center the modal vertically and horizontally
      aria-labelledby="exampleModalToggleLabel2"
      contentClassName="p-0 bg-transparent border-0 shadow-none m-0"
    >
      <ModalBody className="p-0">
        <div className="w-100 d-flex flex-column">
          <div className="modal-content p-4">
            <div className="d-flex gap-3 flex-column justify-content-center align-items-center">
              <h1 className="black fs-18 fw-600 mb-0">Bulk Upload</h1>

              <div className="file_select_box2 w-100 d-flex gap-1 flex-column justify-content-center align-items-center p-4">
                <FileUploader handleChange={handleChange} name="file" types={fileTypes} onTypeError={
                  (error) => {
                    toast.error(error);
                  }
                } dropMessageStyle={{ backgroundColor: '#c2c2c2', color: "transparent", border: 0 }}>
                  <div className="d-flex gap-2 flex-column justify-content-center align-items-center">
                    <div className="d-flex gap-2 flex-column justify-content-center align-items-center">
                      <Image src={SvgImages.select_file} style={{ height: 36, filter: ImageFilters.lightGrey.filter }} />
                      <h2 className="primary fs-14  fw-500 mb-0">Drag and drop file here</h2>
                    </div>

                    <h3 className="subText fs-14  fw-500 mb-0">OR</h3>

                    <ButtonWithIcon text={"Browse Files"} icon={SvgImages.file} />

                    <h3 className="subText fs-12  fw-400 mb-0 mt-2 text-center">We only support CSV and Excel format here. Here's a sample of
                      how it should look like</h3>
                  </div>
                </FileUploader>
                <a href={ApiConstants.FILE_FETCH_URL + "Sample/BulkUploadQuestions.xlsx"} className="primary fs-14 fw-600 mb-0" style={{ borderBottom: "1px solid #14489f", zIndex: 999 }}>Click to Download Sample File</a>
              </div>

            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};